// Google Ads (gtag.js) — tag global + conversão de cadastro.
//
// REACT_APP_GOOGLE_ADS_ID carrega a tag base em todas as páginas.
// REACT_APP_GOOGLE_ADS_CONVERSION_LABEL só existe depois de criar a ação de
// conversão no Google Ads e escolher "Instalar usando o snippet do evento"
// (é o valor depois da barra em `send_to: 'AW-.../LABEL'`). Sem ele o evento
// de conversão não dispara — só a tag base fica carregada.

const GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const GOOGLE_ADS_CONVERSION_LABEL = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL;

export const loadGoogleAdsTag = () => {
	if (!GOOGLE_ADS_ID || document.getElementById("google-ads-gtag")) {
		return;
	}

	const script = document.createElement("script");
	script.id = "google-ads-gtag";
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
	document.head.appendChild(script);

	window.dataLayer = window.dataLayer || [];
	window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
	window.gtag("js", new Date());
	window.gtag("config", GOOGLE_ADS_ID);
};

export const trackSignupConversion = () => {
	if (!GOOGLE_ADS_ID || !GOOGLE_ADS_CONVERSION_LABEL || typeof window.gtag !== "function") {
		return;
	}

	window.gtag("event", "conversion", {
		send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_CONVERSION_LABEL}`,
	});
};
